import React from 'react';
import { mockTeam } from '../mock';
import { Phone, Award, CheckCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

const About = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <span className="px-6 py-2 bg-black text-white rounded-full text-sm font-semibold tracking-wider uppercase inline-block mb-4">
            Who We Are
          </span>
          <h2 className="text-5xl md:text-6xl font-extrabold text-black mb-6 tracking-tight">
            About Structure Savers
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-light leading-relaxed">
            With years of expertise in construction and repair services, we are committed to delivering excellence in every project. Our team of skilled professionals ensures quality workmanship and customer satisfaction.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20">
          <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl p-10 border-0 shadow-lg hover:shadow-2xl transition-all duration-500">
            <Award className="w-14 h-14 text-black mb-6" />
            <h3 className="text-3xl font-extrabold text-black mb-4">Our Mission</h3>
            <p className="text-gray-600 text-lg leading-relaxed font-light">
              To provide reliable, high-quality construction and repair services that protect and enhance the structural integrity of your property. We believe in building lasting relationships through trust and exceptional craftsmanship.
            </p>
          </div>
          <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl p-10 border-0 shadow-lg hover:shadow-2xl transition-all duration-500">
            <CheckCircle className="w-14 h-14 text-black mb-6" />
            <h3 className="text-3xl font-extrabold text-black mb-4">Why Choose Us</h3>
            <ul className="text-gray-600 text-lg space-y-4 font-light">
              <li className="flex items-start">
                <span className="w-2 h-2 bg-black rounded-full mt-2.5 mr-4 flex-shrink-0"></span>
                <span>Experienced and certified professionals</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-black rounded-full mt-2.5 mr-4 flex-shrink-0"></span>
                <span>Quality materials and workmanship</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-black rounded-full mt-2.5 mr-4 flex-shrink-0"></span>
                <span>Timely project completion</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-black rounded-full mt-2.5 mr-4 flex-shrink-0"></span>
                <span>Competitive pricing</span>
              </li>
            </ul>
          </div>
        </div>

        <div>
          <h3 className="text-4xl font-extrabold text-black text-center mb-12 tracking-tight">Our Team</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {mockTeam.map((member) => (
              <Card key={member.id} className="border-0 shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 rounded-3xl overflow-hidden group">
                <CardHeader className="text-center bg-gradient-to-br from-gray-900 to-black pt-12 pb-8">
                  <div className="w-28 h-28 bg-white rounded-3xl mx-auto mb-6 flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-2xl">
                    <span className="text-black text-4xl font-extrabold">
                      {member.name.split(' ').map(n => n[0]).join('')}
                    </span>
                  </div>
                  <CardTitle className="text-2xl font-extrabold text-white">{member.name}</CardTitle>
                  <p className="text-gray-300 font-medium mt-2">{member.role}</p>
                </CardHeader>
                <CardContent className="text-center space-y-3 pt-8 pb-8">
                  <div className="flex items-center justify-center space-x-3 text-lg">
                    <Phone className="w-5 h-5 text-black" />
                    <span className="text-gray-700 font-semibold">{member.phone}</span>
                  </div>
                  <p className="text-gray-600 font-light">{member.services}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;